import { NotFoundPage } from './pages/NotFoundPage';
import { FaqPage } from './pages/FAQ';
import { ImprintPage } from './pages/ImprintPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TicketDetails } from './pages/TicketDetails';
import { Ticketing } from './pages/Ticketing';

export const routes = [
  {
    path: '/',
    element: <Ticketing />,
  },
  {
    path: '/tickets/:ticketId',
    element: <TicketDetails />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/imprint',
    element: <ImprintPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  { path: '*', element: <NotFoundPage /> },
];
